import { Badge, Box, Grid, Hidden, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import moment from "moment-timezone";
import React from "react";
import { useHistory } from "react-router-dom";
import { Routes } from "../../router/routes";
import { FontFamilySwitch, generateImageUrl, img_size } from "../../utils";
const useStyles = makeStyles((theme) => ({
  root: {
    padding: "8px",
    backgroundColor: "white",
    borderRadius: theme.palette.borderRadius,
    marginTop: "10px",
    boxShadow: "0px 0px 4px #00000029",
    cursor: "pointer",
  },
  name: {
    fontSize: "0.875rem",
    fontFamily: FontFamilySwitch().bold,
    color: theme.typography.color.primary,
  },
  posted: {
    fontSize: "0.75rem",
    color: theme.typography.color.Tertiary,
  },
  title: {
    fontSize: "0.875rem",
    fontFamily: FontFamilySwitch().bold,
    color: theme.typography.color.primary,

  },
  title1: {
    fontSize: "0.875rem",
    fontFamily: FontFamilySwitch().bold,
    color: "#4E5A6B",

  },
  dis: {
    fontSize: "0.75rem",
    fontFamily: FontFamilySwitch().semiBold,
    color: theme.typography.color.secondary,
    marginTop: "4px",
    cursor: "pointer",
  },
  img: {
    width: "80px",
    height: "80px",
    borderRadius: theme.palette.borderRadius,
  },
  health: {
    fontSize: "0.75rem",
    color: "#98A0AC",
    fontFamily: FontFamilySwitch().bold,
    background: "#E4E8EE",
    padding: "1px 8px",
    borderRadius: "4px",
  },
  dot: {
    position: "absolute",
    top: "-10px",
    // right: "-19px",
    width: "30px",
    height: "30px",
  },
  announsmentnot: {
    backgroundColor: "#E6F9FF",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "80px",
    height: "80px",
    borderRadius: theme.palette.borderRadius,
  },
}));

export const Notification = (props) => {
  const { t=()=>false } = (props)
  const classes = useStyles(props);
  const history = useHistory();
  const language = localStorage.getItem("i18nextLng")

  const redirect = (val) => {
    props?.viewNotification(val);
    if (val.content_type === "Announcement") {
      history.push(Routes.announcementDetails + "?Id=" + val?.id);
    }
  };
  return (
    <div>
      <Grid
        container
        justifyContent="center"
        spacing={1}
        className={props.data.active ? classes.roots : classes.root}
        onClick={() => redirect(props?.data)}
      >
        <Grid xs={3.5} md={2} sm={2} lg={2}>
          {props?.data?.description?.[0]?.images ? (
            <>
              <img
                src={generateImageUrl(props?.data.description[0]?.images, img_size.small_square)}
                alt="imgg"
                className={classes.img}
              />
            </>
          ) : (
            <>
              <Box className={classes.announsmentnot}>
                <img src="/images/announsmentnot.svg" alt="announsment" />
              </Box>
            </>
          )}
        </Grid>
        <Grid item xs={8.5} md={10} sm={10} lg={10}>
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              position: "relative",
            }}
          >
            <Box>
              <span variant="subtitle2" noWrap className={classes.health}>
                {props?.data?.category}
              </span>
              <Typography
                className={
                  props?.data?.is_read ? classes.title1 : classes.title
                }
                noWrap
                style={{ marginBottom: "6px" }}
              >
                <Hidden smUp>
                  {props?.data?.title?.length > 30 ? (
                    <>{props?.data?.title.slice(0, 25)}...</>
                  ) : (
                    props?.data?.title
                  )}
                </Hidden>
                <Hidden smDown>
                  {props?.data?.title?.length > 50 ? (
                    <>{props?.data?.title.slice(0, 50)}...</>
                  ) : (
                    props?.data?.title
                  )}
                </Hidden>

              </Typography>
              <Typography className={classes.posted}>
                {t("Posted at")}{""}
                {moment(new Date(props?.data?.triggered_at)).fromNow()}
              </Typography>
            </Box>
            {!props?.data?.is_read && (
              <Box sx={{ left: language === "ar" && "-25px", right: language !== "ar" && "-19px" }} className={classes.dot}>
                <Badge color="primary" variant="dot" />
              </Box>
            )}
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};
